'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = undefined;
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _mediaQueries = require('@marmalade/themes/lib/media-queries');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var global = function global() {
  return {
    margin: '0 0 1em',
    lineHeight: '1.3'
  };
};
var H1 = exports.H1 = (0, _glamorous2.default)('h1')(global, {
  fontSize: '3.6rem'
}, function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({}, (0, _mediaQueries.atLeast)(theme.breakpoint_sm), {
    fontSize: '4.6rem'
  });
});
var H2 = exports.H2 = (0, _glamorous2.default)('h2')(global, {
  fontSize: '2.6rem'
}, function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({}, (0, _mediaQueries.atLeast)(theme.breakpoint_sm), {
    fontSize: '3rem'
  });
});
var H3 = exports.H3 = (0, _glamorous2.default)('h3')(global, {
  fontSize: '2.2rem'
}, function (_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({}, (0, _mediaQueries.atLeast)(theme.breakpoint_sm), {
    fontSize: '2.4rem'
  });
});
var H4 = exports.H4 = (0, _glamorous2.default)('h4')(global, {
  fontSize: '1.8rem'
}, function (_ref7) {
  var theme = _ref7.theme;
  return _defineProperty({}, (0, _mediaQueries.atLeast)(theme.breakpoint_sm), {
    fontSize: '2rem'
  });
});
var H5 = exports.H5 = (0, _glamorous2.default)('h5')(global, {
  fontSize: '1.6rem'
}, function (_ref9) {
  var theme = _ref9.theme;
  return _defineProperty({}, (0, _mediaQueries.atLeast)(theme.breakpoint_sm), {
    fontSize: '1.8rem'
  });
});
var H6 = exports.H6 = (0, _glamorous2.default)('h6')(global, {
  fontSize: '1.4rem'
}, function (_ref11) {
  var theme = _ref11.theme;
  return _defineProperty({}, (0, _mediaQueries.atLeast)(theme.breakpoint_sm), {
    fontSize: '1.6rem'
  });
});